import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography
} from "@material-ui/core";
import { Check, ExpandMore, Close } from "@material-ui/icons";
import CheckboxWithLabel from "Components/formControls/CheckboxWithLabel";
import React from "react";
import { useFormContext } from "react-hook-form";
import { checkArrayLength } from "src/utils";
import useStyles from "../../styles";

const DefaultQuestions = () => {
  const classes = useStyles();
  const {
    register,
    watch,
    setValue,
  } = useFormContext();
  const { configuration, disabledView } = watch();

  return (
    <Box className={classes.root} mb={1}>
      <Accordion data-testid="accord" className={classes.accordion}>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          className={classes.accordionSummary}>
          <Typography className={classes.heading}>
            Default questions
            <span className="f-gray font-12 font-regular ml10">
              (
              {checkArrayLength(
                configuration?.onboardingQuestions?.default.filter(
                  res => res.isSelected
                )
              )}{" "}
              selected)
            </span>
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          <Box className={classes.targetTypes}>
            {configuration?.onboardingQuestions?.default.map((question, i) => (
              <Box px={2} mb={2}>
                {disabledView ? (
                  <ul className={classes.qusList}>
                    <li>
                      <span>
                        {question.isSelected ? <Check fontSize="small" className={classes.checkIcon} /> : <Close fontSize="small" className={classes.crossIcon} />}
                      </span>
                      <span className={question.isSelected ? "" : classes.crossIcon}>{question.question}</span>
                    </li>
                  </ul>
                ) :
                  <CheckboxWithLabel
                    register={register(
                      `configuration.onboardingQuestions.default.${i}.isSelected`
                    )}
                    data-testid="checkbox-test"
                    label={question.question}
                    checked={question.isSelected}
                    name={"configuration.onboardingQuestions.default"}
                    // disabled={disabledView}
                    handleChange={() =>
                      setValue(
                        `configuration.onboardingQuestions.default.${i}.isSelected`,
                        !question?.isSelected
                      )
                    }
                  />}
              </Box>
            ))}
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default DefaultQuestions;
